import { COLORS, RADIUS, SHADOWS, fontFamilyFor } from "../../theme";

const fontFor = (isArabic) => fontFamilyFor(isArabic ? "ar" : "en");

export const Style = {
  main: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "calc(100vh - 180px)",
    color: COLORS.white,
    gap: "16px",
    p: { xs: "0 16px", sm: 0 },
  },
  badgeCircle: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.peach})`,
    color: COLORS.forest,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    boxShadow: SHADOWS.card,
  },
  badgeCircleFail: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #c0392b, #e57373)",
    color: COLORS.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    boxShadow: SHADOWS.card,
  },
  statusText: (isArabic) => ({
    fontWeight: 800,
    color: COLORS.white,
    fontFamily: fontFor(isArabic),
    fontSize: "26px",
  }),
  message: (isArabic) => ({
    fontWeight: 400,
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    color: "rgba(255,255,255,0.6)",
    width: "100%",
    maxWidth: "335px",
    textAlign: "center",
  }),
  actionButton: (isArabic) => ({
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    color: `${COLORS.dark} !important`,
    background: COLORS.peach,
    "&:hover": { background: COLORS.gold },
    maxWidth: { xs: "600px", sm: "300px" },
    height: "56px",
    borderRadius: RADIUS.pill,
    boxShadow: "none",
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100vw - 40px)", sm: "100%" },
    bottom: "120px",
    left: "20px",
  }),
  backButton: (isArabic) => ({
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    color: `${COLORS.white} !important`,
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.3)",
    "&:hover": { borderColor: COLORS.gold, color: `${COLORS.gold} !important` },
    maxWidth: { xs: "600px", sm: "300px" },
    height: "56px",
    borderRadius: RADIUS.pill,
    boxShadow: "none",
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100vw - 40px)", sm: "100%" },
    bottom: "40px",
    left: "20px",
  }),
};
